import http from '@/fetch';
const user = {
  state: {
    userInfo: {...JSON.parse(sessionStorage.getItem('userInfo') || '{}')},
    // refreshed: false,
  },
  getters: {

  },
  mutations: {
    setUserInfo(state, userInfo) {
      const {
        corpName,
        corpCode,
        corpList,
        token,
        userPhone,
        // orderSource,
        // accountNo,
        // checked,
      } = userInfo;
      if (corpName || corpName===''){
        state.userInfo.corpName = corpName;
      }
      if (corpCode || corpCode===''){
        state.userInfo.corpCode = corpCode;
      }
      if (corpList || corpList===''){
        state.userInfo.corpList = corpList;
      }
      if (userPhone|| userPhone===''){
        state.userInfo.userPhone = userPhone;
      }
      // if (checked|| checked===''){
      //   state.userInfo.checked = checked;
      // }
      if (token || token===''){
        state.userInfo.token = token;
      }

      // if (orderSource || orderSource===''){
      //   state.userInfo.orderSource = orderSource;
      // }
      // if (accountNo || accountNo===''){
      //   state.userInfo.accountNo = accountNo;
      // }

      sessionStorage.setItem('userInfo', JSON.stringify(state.userInfo));
    },
    clearUserInfo(state){
      state.userInfo = {
        // corpName: '',
      };
      sessionStorage.removeItem('userInfo');
      // sessionStorage.setItem('userInfo', JSON.stringify(state.userInfo));
    },
  },
  actions: {
    async getUserInfo(context,to={}) {
      const url = '/paycenter-charge/api/worktable/user/info';
      const userInfoRes = await http.get(url);

      if (userInfoRes.success){
        // 默认主体选择第一个主体
        const {corpList,userPhone} = userInfoRes.data;
        let index = 0;
        // userCenterCorpCode 当前主体用户中心对饮的企业码
        //比对url中的userCenterCorpCode获取对应的主体
        const userCenterCorpCode = to?.query?.userCenterCorpCode??'';
        if (userCenterCorpCode){
          index = corpList.findIndex(item=>item.key === userCenterCorpCode);
        }

        const item = corpList?.[index]??{};
        // context.state.refreshed = true;
        context.commit('setUserInfo',{
          corpCode: item.key,
          corpName: item.value,
          corpList: corpList||'',
          userPhone,
          // checked,
        });
      }
    },
  },
};

export default user;
